import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from '../decorators';
import { GetUserLocations } from 'domain/usecases/get-user-locations';
import { RemoteGetUserLocations } from 'data/usecases/remote-get-user-locations';

export const makeRemoteGetUserLocations = (): GetUserLocations => {
  return new RemoteGetUserLocations(makeApiUrl('/users/userlocations'), makeAuthorizeHttpClientDecorator());
};
